<script src="//unpkg.com/v-viewer/dist/v-viewer.js"></script>

<template>
  <div>
    <div v-if="loading || !formLoaded">
      <span class="spinner"></span>
    </div>
    <div v-if="!loading && formLoaded">
      <b-form
        @submit.stop.prevent="onSubmit"
        :class="{
          'p-3 box-shadow2 rounded': !isDarkMode,
          'dark-div p-3 box-shadow2 rounded': isDarkMode
        }"
      >
        <b-row>
          <b-col>
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Store Id
                <span class="text-danger">*</span>
              </template>
              <multiselect
                id="input-products"
                v-model="selectedStore"
                :options="storeOptions"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :show-no-results="false"
                :disabled="isUpdateForm"
                label="label"
                track-by="value"
                placeholder="Select Store ID"
                @input="onSelectStore"
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
              />
              <b-form-invalid-feedback id="input-store-invalid">Please select a Store Id.</b-form-invalid-feedback>
            </b-form-group></b-col
          >
          <b-col>
            <b-form-group id="group-articleCode" label-for="input-articleCode">
              <template v-slot:label>
                Article Code
                <span class="text-danger">*</span>
              </template>

              <multiselect
                id="input-articleCode"
                v-model="selectedArticle"
                :options="articleOptions"
                :searchable="true"
                :loading="isSearchingArticles"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :show-no-results="false"
                :disabled="isUpdateForm || !form.storeid"
                label="label"
                track-by="value"
                placeholder="Select Store ID first"
                @input="onSelectArticle"
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
              />

              <b-form-invalid-feedback id="input-name-invalid"
                >Customer Mobile number must be 10 digit long.</b-form-invalid-feedback
              >
            </b-form-group></b-col
          >
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="group-cnQuantity" label-for="input-cnQuantity">
              <template v-slot:label>
                CN Quantity
                <span class="text-danger">*</span>
              </template>
              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-cnQuantity"
                type="number"
                v-model="form.cnQuantity"
                :disabled="isUpdateForm || (formType === 'new' && !!form.cnQuantity)"
                placeholder="Enter CN Quantity"
              ></b-form-input>
              <b-form-invalid-feedback id="input-name-invalid"
                >Please enter Transaction amount.</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="group-articleDescription" label-for="input-articleDescription">
              <template v-slot:label>
                Article description
                <span class="text-danger">*</span>
              </template>
              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-articleDescription"
                type="text"
                v-model="form.articleDescription"
                :disabled="isUpdateForm || (formType === 'new' && !!form.articleDescription)"
                placeholder="Enter Article description"
                @input="onManualEdit('articleDescription')"
              ></b-form-input>
              <b-form-invalid-feedback id="input-name-invalid">Please enter Transaction ID.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12" lg="6">
            <b-form-group id="group-complainDateWithBrand" label-for="input-complainDateWithBrand">
              <template v-slot:label>
                Select Complaind Date with Brand
                <span class="text-danger">*</span>
              </template>
              <b-row>
                <b-col>
                  <b-input-group class="box-shadow2 mb-2">
                    <b-input-group-append>
                      <b-form-datepicker
                        button-only
                        id="start-datepicker"
                        placeholder="Select Date"
                        :max="maxDate"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        v-model="form.complainDateWithBrand"
                        :disabled="isUpdateForm"
                        class="box-shadow3"
                      ></b-form-datepicker>
                    </b-input-group-append>
                    <b-form-input
                      id="example-input"
                      v-model="form.complainDateWithBrand"
                      type="text"
                      placeholder="Select Date"
                      autocomplete="off"
                      :class="{
                        '': !isDarkMode,
                        'bg-dark text-light placeholder-light': isDarkMode
                      }"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="6">
            <b-form-group id="group-invoiceDate" label-for="input-invoiceDate">
              <template v-slot:label>
                Select Invoice Date
                <span class="text-danger">*</span>
              </template>
              <b-row>
                <b-col>
                  <b-input-group class="box-shadow2 mb-2">
                    <b-input-group-append>
                      <b-form-datepicker
                        button-only
                        id="input-invoiceDate"
                        placeholder="Select Date"
                        :max="maxDate"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        v-model="form.invoiceDate"
                        :disabled="isUpdateForm || (formType === 'new' && !!form.invoiceDate)"
                        class="box-shadow3"
                        @input="onManualEdit('invoiceDate')"
                      ></b-form-datepicker>
                    </b-input-group-append>
                    <b-form-input
                      id="input-invoiceDate"
                      v-model="form.invoiceDate"
                      type="text"
                      placeholder="Select Date"
                      autocomplete="off"
                      :class="{
                        '': !isDarkMode,
                        'bg-dark text-light placeholder-light': isDarkMode
                      }"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            ><b-form-group id="group-issueWithProduct" label-for="input-issueWithProduct">
              <template v-slot:label>
                Issue with the Product
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="form.issueWithProduct"
                id="input-issueWithProduct"
                placeholder="Select Store Ids"
                label="text"
                :options="issueType"
                :disabled="isUpdateForm"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
              >
              </b-form-select>
              <b-form-invalid-feedback id="input-store-invalid">Please select a Store Id.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group id="group-complainNumberSharedByBrand" label-for="input-complainNumberSharedByBrand">
              <template v-slot:label>
                Complaint Number shaired by Brand
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-complainNumberSharedByBrand"
                type="number"
                v-model="form.complainNumberSharedByBrand"
                placeholder="Enter Number"
                :disabled="isUpdateForm"
              ></b-form-input>

              <b-form-invalid-feedback id="input-name-invalid"
                >Customer Mobile number must be 10 digit long.</b-form-invalid-feedback
              >
            </b-form-group></b-col
          >
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="group-replacementTagNumber" label-for="input-replacementTagNumber">
              <template v-slot:label>
                Replacement TAG Number
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-replacementTagNumber"
                type="number"
                v-model="form.replacementTagNumber"
                placeholder="Enter Number"
                :disabled="isUpdateForm"
              ></b-form-input>

              <b-form-invalid-feedback id="input-name-invalid"
                >Customer Mobile number must be 10 digit long.</b-form-invalid-feedback
              >
            </b-form-group></b-col
          >
          <b-col>
            <b-form-group id="group-customerMobileNumber" label-for="input-customerMobileNumber">
              <template v-slot:label>
                Customer Number
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                id="input-customerMobileNumber"
                type="number"
                v-model="form.customerMobileNumber"
                placeholder="Enter Number"
                :disabled="isUpdateForm"
                @input="validateCustomerPhone"
                maxlength="10"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              ></b-form-input>

              <b-form-invalid-feedback id="input-name-invalid"
                >Customer Mobile number must be 10 digit long.</b-form-invalid-feedback
              >
            </b-form-group></b-col
          >
        </b-row>

        <b-row>
          <b-col
            ><b-form-group id="group-issueResolved" label-for="input-issueResolved">
              <template v-slot:label>
                Select Status
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="form.issueResolved"
                id="input-issueResolved"
                placeholder="Select Store Ids"
                label="text"
                :options="statusTypes"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
              >
              </b-form-select>
              <b-form-invalid-feedback id="input-store-invalid">Please select a Store Id.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="group-invoiceNumber" label-for="input-invoiceNumber">
              <template v-slot:label>
                Invoice Number / Bill Number
                <span class="text-danger">*</span>
              </template>

              <b-form-select
                v-model="selectedBillNumber"
                id="input-invoiceNumber"
                placeholder="Select Bill Number"
                :options="billNumberOptions"
                :disabled="isUpdateForm || !form.articleCode || isLoadingBillNumbers"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
                @input="onSelectBillNumber"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled>Select Bill Number</b-form-select-option>
                </template>
              </b-form-select>

              <b-form-invalid-feedback id="input-name-invalid">Please select a Bill Number.</b-form-invalid-feedback>
            </b-form-group></b-col
          >
        </b-row>
        <b-row>
          <b-col>
            <div v-viewer>
              <b-form-group id="group-products" label-for="input-products">
                <template v-slot:label>
                  {{ isUpdateForm ? 'Uploaded Image' : 'Upload Image' }}
                  <span class="text-danger">*</span>
                </template>
                <input
                  v-if="!isUpdateForm"
                  type="file"
                  @change="handleImageUpload($event)"
                  accept=".jpg, .jpeg, .png"
                  multiple
                />
                <div v-if="imagePreview && imagePreview.length > 0" class="mt-2 imageView">
                  <img
                    v-for="(imgSrc, index) in imagePreview"
                    :key="index"
                    :src="imgSrc"
                    alt="Preview Image"
                    class="mx-2"
                    style="width: 120px; height: 120px"
                  />
                  <link href="//unpkg.com/viewerjs/dist/viewer.css" rel="stylesheet" />
                </div>
                <div v-if="imageValidationError" class="text-danger mt-1">
                  <small>Please upload at least one image before submitting.</small>
                </div>
              </b-form-group>
            </div>
          </b-col></b-row
        >
        <!-- Button Secection   -->
        <b-form-group>
          <b-row class="mt-2">
            <b-col class="text-right">
              <b-button
                class="box-shadow2 mr-2"
                size="sm"
                :variant="isDarkMode ? 'outline-success' : 'success'"
                type="submit"
                :disabled="loading || !isFormValid"
              >
                <span class="spinner spinner-white" v-if="loading"></span>
                <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Submit
              </b-button>

              <b-button
                class="ml-2 box-shadow2"
                size="sm"
                :variant="isDarkMode ? 'outline-warning' : 'warning'"
                :to="{ path: `/eneTracker` }"
              >
                <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import moment from 'moment';
import { mapGetters, mapState, mapActions } from 'vuex';
import configService from '@/services/configService';
import router from '@/router';
import Multiselect from 'vue-multiselect';
import popService from '@/services/popService';
import eneTrackerService from '@/services/eneTracker';
import VueViewer from 'v-viewer';
import Vue from 'vue';

Vue.use(VueViewer);
export default {
  name: 'TransactionFrom',
  components: {
    Multiselect
  },
  props: {
    listUrl: String,
    formType: String,
    documentType: String,
    loading: Boolean
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  data() {
    return {
      inputs: [
        {
          name: ''
        }
      ],

      formLoaded: true,
      storeid: '',
      stores: [],
      complainNumberSharedByBrand: '',
      issueType: [
        { value: null, text: 'Select Issue' },
        { value: 'DEFECTIVE', text: 'Defective' },
        { value: 'PHYSICAL_DAMAGE', text: 'Physical Damage' },
        { value: 'PARTS_MISSING_WITH_THE_PACKAGE', text: 'Parts Missing with the package' },
        { value: 'PRODUCT_EXCHANGE_REQUESTED_BY_CUSTOMER', text: 'Product Exchange Requested by Customer' }
      ],
      statusTypes: [
        { value: null, text: 'Select' },
        { value: 'PENDING', text: 'Pending' },
        { value: 'RESOLVED', text: 'Resolved' },
        { value: 'NOT_RESOLVED', text: 'Not Resolved' }
      ],
      currentStatus: '',
      form: {
        articleCode: null,
        articleDescription: '',
        complainNumberSharedByBrand: null,
        customerMobileNumber: null,
        cnQuantity: null,
        replacementTagNumber: null,
        complainDateWithBrand: moment().format('YYYY-MM-DD'),
        invoiceDate: moment().format('YYYY-MM-DD'),
        invoiceNumber: null,
        storeid: '',
        issueWithProduct: null,
        issueResolved: 'PENDING',
        file: [],
        fileName: []
      },
      maxDate: moment().format('YYYY-MM-DD'),
      dateTimeFormat: configService.get('format').pickerDateTime,
      complainDateWithBrand: moment().format('YYYY-MM-DD'),
      invoiceDate: moment().format('YYYY-MM-DD'),
      imagePreview: null,
      file: [], // Store existing images for update forms
      // article search state
      selectedArticle: null,
      isSearchingArticles: false,
      articleOptions: [],
      // store search state
      selectedStore: null,
      storeOptions: [],
      // bill number state
      billNumberOptions: [],
      selectedBillNumber: null,
      isLoadingBillNumbers: false,
      currentStoreId: null,
      // image validation
      imageValidationError: false,
      // Track auto-filled fields - validation should be false for these
      autoFilledFields: {
        storeid: false,
        articleCode: false,
        cnQuantity: false,
        articleDescription: false,
        invoiceDate: false,
        invoiceNumber: false
      }
    };
  },
  validations() {
    const formValidation = {
      customerName: {
        required
      },
      customerMobileNumber: {
        required,
        maxLength: maxLength(10),
        minLength: minLength(10)
      },
      smMobile: {
        required,
        validateMobileNumbers(value) {
          if (!value) return false;
          const numbers = value.split(',').map(num => num.trim());
          return numbers.every(num => /^\d{10}$/.test(num));
        }
      },

      transactionId: {
        required
      },
      transactionAmount: {
        required
      },
      complainDateWithBrand: {
        required
      }
      // approverRemarks: {
      //   required: this.formType === 'update'
      // }
    };

    if (this.formType === 'new') {
      formValidation.customerName.required = required;
      formValidation.customerMobileNumber.required = required;
      formValidation.smMobile.required = required;
      formValidation.transactionId.required = required;
      formValidation.transactionAmount.required = required;
    }

    return { form: formValidation };
  },
  mounted() {
    this.getStoreByUser({ router });

    this.$nextTick(async () => {
      if (this.formType === 'new') {
        this.formLoaded = true;
        this.$v.$touch();
        this.$v.$reset();
      }
    });
  },
  computed: {
    metaDescription() {
      return this.formType === 'new' ? 'Add new Transaction Complain' : 'Update Transaction Complain';
    },
    isUpdateForm() {
      return this.formType === 'update';
    },
    isDisable() {
      return this.currentStatus === 'IN PROGRESS';
    },
    isFormValid() {
      // Check all required fields are filled
      const hasStoreId = !!this.selectedStore && !!this.form.storeid;
      const hasArticleCode = !!this.selectedArticle && !!this.form.articleCode;
      const hasCnQuantity = this.form.cnQuantity !== null && this.form.cnQuantity !== '';
      const hasArticleDescription = !!this.form.articleDescription && this.form.articleDescription.trim() !== '';
      const hasComplainDate = !!this.form.complainDateWithBrand;
      const hasInvoiceDate = !!this.form.invoiceDate;
      const hasIssueWithProduct = this.form.issueWithProduct !== null;
      const hasComplainNumber =
        this.form.complainNumberSharedByBrand !== null && this.form.complainNumberSharedByBrand !== '';
      const hasReplacementTagNumber = this.form.replacementTagNumber !== null && this.form.replacementTagNumber !== '';
      const hasCustomerMobileNumber =
        this.form.customerMobileNumber !== null && this.form.customerMobileNumber.toString().length === 10;
      const hasIssueResolved = this.form.issueResolved !== null;
      const hasInvoiceNumber = !!this.selectedBillNumber && !!this.form.invoiceNumber;
      const hasImage =
        (this.form.file && this.form.file.length > 0) ||
        (this.imagePreview && this.imagePreview.length > 0) ||
        (this.file && this.file.length > 0);

      return (
        hasStoreId &&
        hasArticleCode &&
        hasCnQuantity &&
        hasArticleDescription &&
        hasComplainDate &&
        hasInvoiceDate &&
        hasIssueWithProduct &&
        hasComplainNumber &&
        hasReplacementTagNumber &&
        hasCustomerMobileNumber &&
        hasIssueResolved &&
        hasInvoiceNumber &&
        hasImage
      );
    },
    ...mapGetters('alert', ['errorMessages']),
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('auth', ['user']),
    ...mapState('cstSubmission', ['store']),
    ...mapState('eneTracker', ['baseUrl', 'pagination', 'complainList', 'complain', 'images', 'creditNote'])
  },
  methods: {
    ...mapActions('transactionComplain', ['getOne', 'postOne', 'patchOne', 'uploadImage']),
    ...mapActions('eneTracker', ['getCreditNoteByArticle', 'uploadEnETrackerImage']),
    ...mapActions('cstSubmission', ['getStoreByUser']),
    handleButtonDisable() {
      //for store STORE_SALES_MANAGER
      if (this.formType === 'new' && this.ifStoreManager()) {
        return true;
      } else if (this.ifFinanceAdmin() && (this.currentStatus === 'IN PROGRESS' || this.currentStatus === 'CREATED')) {
        return true;
      }
      return false;
    },
    ifAdmin() {
      const isAdmin = this.user.roles.filter(role => role.name === 'ADMIN');
      if (isAdmin.length) {
        return true;
      }
      return false;
    },
    ifStoreManager() {
      const isStoreManager = this.user.roles.filter(role => role.name === 'STORE_SALES_MANAGER');
      if (isStoreManager.length) {
        return true;
      }
      return false;
    },
    ifFinanceAdmin() {
      const isAdmin = this.user.roles.filter(role => role.name === 'FINANCE_ADMIN');
      if (isAdmin.length) {
        return true;
      }
      return false;
    },
    validateSMMobile(value) {
      if (value && value.toString().length > 10) {
        this.form.smMobile = value.toString().slice(0, 10);
      }
    },
    validateCustomerPhone(value) {
      // the use case
      //                @input="validateCustomerPhone"
      if (value && value.toString().length > 10) {
        this.form.customerMobileNumber = value.toString().slice(0, 10);
      }
    },
    handleImageUpload(event) {
      let allAreImages = true;
      this.form.file = [];
      this.imagePreview = [];

      if (event.target.files && event.target.files.length > 0) {
        for (let i = 0; i < event.target.files.length; i++) {
          const file = event.target.files[i];
          if (!file || !file.type.includes('image')) {
            allAreImages = false;
            event.target.value = '';
            Vue.swal({
              title: 'Invalid File',
              text: 'Only image files are allowed.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
            break;
          }
        }

        if (allAreImages) {
          for (let i = 0; i < event.target.files.length; i++) {
            const file = event.target.files[i];
            if (file) {
              this.form.file.push(file);

              const reader = new FileReader();
              reader.onload = e => {
                if (!this.imagePreview) {
                  this.imagePreview = [];
                }
                this.imagePreview.push(e.target.result);
              };
              reader.readAsDataURL(file);
            }
          }
        }
      }
      // Clear validation error when image is selected
      this.imageValidationError = false;
    },
    async onSubmit() {
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //   return false;
      // }

      // Validate image upload for new forms
      if (this.formType === 'new') {
        const hasImages =
          (this.form.file && this.form.file.length > 0) || (this.imagePreview && this.imagePreview.length > 0);

        if (!hasImages) {
          this.imageValidationError = true;
          Vue.swal({
            title: 'Image Required',
            text: 'Please upload at least one image before submitting the form.',
            icon: 'warning',
            confirmButtonText: 'OK'
          });
          return false;
        }
      }

      // For update forms, check if images exist (either uploaded or existing)
      if (this.formType === 'update') {
        const hasImages =
          (this.form.file && this.form.file.length > 0) ||
          (this.imagePreview && this.imagePreview.length > 0) ||
          (this.file && this.file.length > 0);

        if (!hasImages) {
          this.imageValidationError = true;
          Vue.swal({
            title: 'Image Required',
            text: 'Please upload at least one image before submitting the form.',
            icon: 'warning',
            confirmButtonText: 'OK'
          });
          return false;
        }
      }

      // Clear validation error if images are present
      this.imageValidationError = false;

      // Upload images before submitting the form
      if (this.form.file && this.form.file.length > 0) {
        try {
          // Show loading indicator
          Vue.swal({
            title: 'Uploading Images...',
            text: 'Please wait while images are being uploaded.',
            icon: 'info',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            willOpen: () => {
              Vue.swal.showLoading();
            }
          });

          // Upload all images
          const uploadPromises = this.form.file.map(file => {
            return this.uploadEnETrackerImage({ file }, {}, router);
          });

          // Wait for all uploads to complete successfully
          const uploadResults = await Promise.all(uploadPromises);

          // Check if all uploads were successful
          const allUploadsSuccessful = uploadResults.every(result => result && result.success);

          if (!allUploadsSuccessful) {
            Vue.swal.close();
            Vue.swal({
              title: 'Upload Failed',
              text: 'One or more images failed to upload. Please try again.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
            return false;
          }

          // Close loading indicator
          Vue.swal.close();
        } catch (error) {
          Vue.swal.close();
          Vue.swal({
            title: 'Upload Failed',
            text: 'Failed to upload images. Please try again.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
          return false;
        }
      }

      // Only proceed with form submission if upload was successful or no images to upload
      const complain = {
        articleCode: this.form.articleCode,
        articleDescription: this.form.articleDescription,
        complainNumberSharedByBrand: this.form.complainNumberSharedByBrand,
        customerMobileNumber: this.form.customerMobileNumber,
        cnQuantity: this.form.cnQuantity,
        replacementTagNumber: this.form.replacementTagNumber,
        complainDateWithBrand: moment(this.form.complainDateWithBrand).format('YYYY-MM-DD'),
        invoiceDate: moment(this.form.invoiceDate).format('YYYY-MM-DD'),
        invoiceNumber: this.form.invoiceNumber,
        storeId: this.form.storeid,
        storeName: this.store.filter(item => item.storeid === this.form.storeid)?.[0]?.storeName,
        issueWithProduct: this.form.issueWithProduct,
        issueResolved: this.form.issueResolved,
        file: [],
        fileName: [],
        imagesUrl: this.formType === 'new' ? this.images : this.file
      };
      if (this.formType === 'new') {
        this.$emit('add', { complain });
      } else {
        this.$emit('edit', { complain });
      }
      return false;
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
      setTimeout(() => {
        this.$refs.multiselect.$refs.search.focus();
      }, 100);
    },
    async onArticleCodeChange() {
      if (!this.form.articleCode || !this.form.storeid) {
        this.billNumberOptions = [];
        this.selectedBillNumber = null;
        this.form.invoiceNumber = null;
        return;
      }

      // Load bill numbers for selected store and article
      this.isLoadingBillNumbers = true;
      // Save the original invoice number before clearing (to determine if we should auto-select)
      const originalInvoiceNumber = this.form.invoiceNumber;
      this.billNumberOptions = [];
      this.selectedBillNumber = null;
      this.form.invoiceNumber = null;

      try {
        const response = await eneTrackerService.getCreditNoteByArticle({
          storeId: this.form.storeid,
          articleCode: this.form.articleCode
        });

        const rows = response && response.data ? response.data : response || [];
        const list = Array.isArray(rows) ? rows : rows ? [rows] : [];

        // Extract unique bill numbers
        const seen = new Set();
        const uniqueBillNumbers = [];
        list.forEach(item => {
          const billNumber = item.billNumber || item.invoiceNumber;
          if (!billNumber) return;
          if (seen.has(billNumber)) return;
          seen.add(billNumber);
          uniqueBillNumbers.push({
            value: billNumber,
            text: `Bill #${billNumber}`,
            billData: item
          });
        });

        this.billNumberOptions = uniqueBillNumbers;

        // Auto-select if only one bill number is available and no invoice number was previously set
        // This ensures auto-selection only happens for new selections, not when loading existing data
        if (uniqueBillNumbers.length === 1 && !originalInvoiceNumber) {
          const singleBillNumber = uniqueBillNumbers[0].value;
          this.selectedBillNumber = singleBillNumber;
          this.form.invoiceNumber = singleBillNumber;
          // Mark as auto-filled
          this.autoFilledFields.invoiceNumber = true;

          // Fetch the credit note data for the auto-selected bill number
          try {
            const payload = { router };
            if (this.form.articleCode) payload.articleCode = this.form.articleCode;
            if (this.form.storeid) payload.storeId = this.form.storeid;
            if (this.form.invoiceNumber) payload.billNumber = this.form.invoiceNumber;

            await this.getCreditNoteByArticle(payload);
          } catch (e) {
            // no-op, error handled globally
          }
        } else if (originalInvoiceNumber) {
          // Restore the original invoice number if it existed (for update forms)
          this.form.invoiceNumber = originalInvoiceNumber;
          this.selectedBillNumber = originalInvoiceNumber;
        }
      } catch (e) {
        this.billNumberOptions = [];
        // no-op, error handled globally
      } finally {
        this.isLoadingBillNumbers = false;
      }
    },
    async loadAllArticlesOnMount() {
      this.isSearchingArticles = true;
      try {
        const response = await eneTrackerService.getCreditNoteByArticle({});
        const rows = response && response.data ? response.data : response || [];
        const list = Array.isArray(rows) ? rows : rows ? [rows] : [];
        const seen = new Set();
        const unique = [];
        list.forEach(item => {
          const code = item.articleCode || item.code || item.id;
          if (!code) return;
          if (seen.has(code)) return;
          seen.add(code);
          unique.push(item);
        });
        const articles = unique.map(item => ({
          value: item.articleCode || item.code || item.id,
          label: `${item.articleCode || item.code || ''}`.trim(),
          code: item.articleCode || item.code,
          description: item.articleDescription || item.description || ''
        }));
        this.articleOptions = articles;
      } catch (e) {
        console.error('Error loading articles on mount:', e);
        this.articleOptions = [];
      } finally {
        this.isSearchingArticles = false;
      }
    },
    async loadAllArticles() {
      if (!this.form.storeid) {
        this.articleOptions = [];
        return;
      }

      // Check if we already have articles for this store
      if (this.articleOptions && this.articleOptions.length > 0 && this.currentStoreId === this.form.storeid) {
        return;
      }

      this.isSearchingArticles = true;
      try {
        const response = await eneTrackerService.getCreditNoteByArticle({
          storeId: this.form.storeid
        });
        // Service returns response.data which is the array directly from backend
        // Handle both direct array and wrapped responses
        const list = Array.isArray(response)
          ? response
          : response && response.data
          ? Array.isArray(response.data)
            ? response.data
            : [response.data]
          : [];

        // Extract unique article codes from the array
        const seen = new Set();
        const unique = [];
        list.forEach(item => {
          const code = item.articleCode || item.code || item.id;
          if (!code) return;
          if (seen.has(code)) return;
          seen.add(code);
          unique.push(item);
        });
        this.articleOptions = unique.map(item => ({
          value: item.articleCode || item.code || item.id,
          label: `${item.articleCode || item.code || ''}`.trim(),
          code: item.articleCode || item.code,
          description: item.articleDescription || item.description || ''
        }));
        this.currentStoreId = this.form.storeid;
      } catch (e) {
        this.articleOptions = [];
      } finally {
        this.isSearchingArticles = false;
      }
    },
    onSelectStore(option) {
      if (!option) {
        this.selectedStore = null;
        this.form.storeid = '';
        this.selectedArticle = null;
        this.form.articleCode = null;
        this.billNumberOptions = [];
        this.selectedBillNumber = null;
        this.form.invoiceNumber = null;
        this.articleOptions = [];
        this.currentStoreId = null;
        // Reset auto-filled flags
        this.autoFilledFields.storeid = false;
        this.autoFilledFields.articleCode = false;
        return;
      }
      this.form.storeid = option.value;
    },
    async onSelectArticle(option) {
      if (!option) {
        this.selectedArticle = null;
        this.form.articleCode = null;
        this.form.cnQuantity = null;
        this.form.articleDescription = '';
        this.form.issueResolved = 'PENDING';
        this.form.invoiceNumber = null;
        this.billNumberOptions = [];
        this.selectedBillNumber = null;
        // Reset auto-filled flags
        this.autoFilledFields.articleCode = false;
        this.autoFilledFields.articleDescription = false;
        this.autoFilledFields.cnQuantity = false;
        this.autoFilledFields.invoiceNumber = false;
        return;
      }
      this.form.articleCode = option.code || option.value;
      // Optionally prefill description from suggestion list (API will overwrite)
      if (option.description) {
        this.form.articleDescription = option.description;
        this.autoFilledFields.articleDescription = true;
      }
      await this.onArticleCodeChange();
    },
    async onSelectBillNumber(billNumberValue) {
      if (!billNumberValue) {
        this.selectedBillNumber = null;
        this.form.invoiceNumber = null;
        // Reset auto-filled flag when manually cleared
        this.autoFilledFields.invoiceNumber = false;
        return;
      }

      this.form.invoiceNumber = billNumberValue;
      // If manually selected by user (not from auto-fill), mark as not auto-filled
      // This will be called when user manually selects from dropdown
      this.autoFilledFields.invoiceNumber = false;

      // Fetch the specific credit note data for this bill number
      try {
        const payload = { router };
        if (this.form.articleCode) payload.articleCode = this.form.articleCode;
        if (this.form.storeid) payload.storeId = this.form.storeid;
        if (this.form.invoiceNumber) payload.billNumber = this.form.invoiceNumber;

        await this.getCreditNoteByArticle(payload);
      } catch (e) {
        // no-op, error handled globally
      }
    },
    onManualEdit(fieldName) {
      // Reset auto-filled flag when user manually edits a field
      if (this.autoFilledFields[fieldName]) {
        this.autoFilledFields[fieldName] = false;
      }
    }
  },
  watch: {
    async complain(newValue) {
      if (newValue.id !== '') {
        this.form.articleCode = newValue.articleCode;
        this.form.storeid = newValue.storeid;
        this.form.cnQuantity = newValue.cnQuantity;
        this.form.articleDescription = newValue.articleDescription;
        this.form.issueWithProduct = newValue.issueWithProduct;
        this.form.replacementTagNumber = newValue.replacementTagNumber;
        this.form.customerMobileNumber = newValue.customerMobileNumber;
        this.form.issueResolved = newValue.issueResolved;
        this.form.invoiceNumber = newValue.invoiceNumber;
        this.form.complainDateWithBrand = newValue.complainDateWithBrand;
        this.form.complainNumberSharedByBrand = newValue.complainNumberSharedByBrand;
        if (newValue.imagesUrl && newValue.imagesUrl.length > 0) {
          this.file = newValue.imagesUrl;
          this.imagePreview = newValue.imagesUrl.map(image => image);
        }

        // Initialize selected store for display
        if (newValue.storeid) {
          const existingStore = this.storeOptions.find(
            s => s.value === newValue.storeid || s.storeid === newValue.storeid
          );
          if (existingStore) {
            this.selectedStore = existingStore;
          } else if (newValue.storeid) {
            // Create a placeholder option for display
            this.selectedStore = {
              value: newValue.storeid,
              label: newValue.storeid,
              storeid: newValue.storeid,
              storeName: newValue.storeName || ''
            };
          }
        }

        // Initialize selected article and bill number for display
        if (newValue.articleCode) {
          // Set selected article if it exists in options, otherwise create a placeholder
          const existingArticle = this.articleOptions.find(
            a => a.code === newValue.articleCode || a.value === newValue.articleCode
          );
          if (existingArticle) {
            this.selectedArticle = existingArticle;
          } else if (newValue.articleCode) {
            // Create a placeholder option for display
            this.selectedArticle = {
              value: newValue.articleCode,
              label: newValue.articleCode,
              code: newValue.articleCode,
              description: newValue.articleDescription || ''
            };
          }
        }

        // Load bill numbers for the given store and article in edit mode
        if (this.form.storeid && this.form.articleCode) {
          try {
            await this.onArticleCodeChange();
          } catch (e) {
            // ignore; handled globally
          }
        }

        // Ensure selected bill number is visible in the select options
        if (newValue.invoiceNumber) {
          const exists = this.billNumberOptions.some(
            opt => opt && (opt.value === newValue.invoiceNumber || opt.text === newValue.invoiceNumber)
          );
          if (!exists) {
            this.billNumberOptions = [
              { value: newValue.invoiceNumber, text: `Bill #${newValue.invoiceNumber}` },
              ...this.billNumberOptions
            ];
          }
          this.selectedBillNumber = newValue.invoiceNumber;
        }
      }
    },
    store(newValue) {
      if (newValue.length === 1) {
        this.storeids = newValue[0].storeid;
      }
      this.stores = [
        { text: 'Select Store ID', value: '' },
        ...newValue.map(store => ({
          text: `${store.storeName} (${store.storeid})`,
          value: store.storeid
        }))
      ];
      // Format stores for multiselect
      this.storeOptions = newValue.map(store => ({
        value: store.storeid,
        label: `${store.storeName} (${store.storeid})`,
        storeName: store.storeName,
        storeid: store.storeid
      }));
    },
    async 'form.storeid'(newValue, oldValue) {
      // When store changes, reset article and bill number selections
      if (newValue !== oldValue) {
        // Clear article selection if store changes
        if (oldValue && newValue !== oldValue) {
          this.selectedArticle = null;
          this.form.articleCode = null;
          this.billNumberOptions = [];
          this.selectedBillNumber = null;
          this.form.invoiceNumber = null;
          this.articleOptions = [];
          this.currentStoreId = null;
        }
        // Automatically load articles when a new store is selected
        if (newValue) {
          await this.loadAllArticles();
        }
      }
    },

    images(newValue) {
      if (newValue !== null && newValue.length > 0) {
        this.file = newValue;
      }
    },
    user(newValue) {},
    creditNote(newValue) {
      if (newValue) {
        // Mark fields as auto-filled when populated from credit note
        if (newValue.articleDescription) {
          this.form.articleDescription = newValue.articleDescription;
          this.autoFilledFields.articleDescription = true;
        }
        // Don't overwrite storeid if it's already set
        // this.form.storeid = newValue.storeId || this.form.storeid;
        if (newValue.billNumber) {
          this.form.invoiceNumber = newValue.billNumber;
          this.autoFilledFields.invoiceNumber = true;
        }
        if (newValue.billDate) {
          this.form.invoiceDate = moment(newValue.billDate).format('YYYY-MM-DD');
          this.autoFilledFields.invoiceDate = true;
        }
        if (newValue.quantity != null) {
          this.form.cnQuantity = newValue.quantity;
          this.autoFilledFields.cnQuantity = true;
        }

        // Update selected bill number to match the invoice number
        if (this.form.invoiceNumber) {
          this.selectedBillNumber = this.form.invoiceNumber;
        }
      }
    }
  }
};
</script>
<style src="vue-search-select/dist/VueSearchSelect.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.calender {
  display: flex;
  width: auto;
  margin-left: -9px;
  margin-bottom: 0.7rem;
}

.date {
  margin-left: -10px;
}

.upload {
  margin-top: 8px;
}

.videoPlayer {
  width: 25%;
}
</style>
<style scoped>
.textarea-height {
  height: 40px;
  /* Set your desired height here */
}

.imageView {
  display: inline-flex;
  margin: 2px;
}
</style>
